import React from 'react';
import { Text } from '~/components';

export interface DateTextProps {
  children: string | React.ReactNode;
}

const DateText: React.FC<DateTextProps> = ({ children }) => {
  return (
    <Text className="text-gray-700 font-medium text-lg flex-1 text-right">
      {children}
    </Text>
  );
};

export default DateText;
